import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const OneAccordBidSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["1accord"],
    },
    params: {
      type: "object",
      properties: {
        tagId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
      },
      required: ["tagId"],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
